import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import { getAdjustment } from "services/data.internal.service";

const columns = [
  { label: "Zone ID", id: "zoneID" },
  { label: "Location ID", id: "locationID" },
  { label: "SKU Code", id: "skuCode" },
  { label: "Pallet Nbr", id: "palletNbr" },
  { label: "Carton ID", id: "cartonID" },
  { label: "Expiry Date", id: "expiryDate" },
  { label: "On Hand Qty", id: "quantity", align: "right" },
  { label: "Adjust Qty", id: "adjustQuantity", align: "right" },
  { label: "Adjusted Qty", id: "adjustedQuantity", align: "right" },
  { label: "Base UOM", id: "baseUOM" },
];

function AdjustmentDrawer({ open, setOpen, adjRequest, setAdjRequest }) {

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["adj-log", { adjRequest }],
    queryFn: () => getAdjustment(adjRequest),
    enabled: adjRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Adjustment Number : </b>
                {item.adjustmentNo}
              </Grid>
              <Grid item xs={6}>
                <b>Adjustment Date : </b>
                {item.adjustmentDate}
              </Grid>
              <Grid item xs={6}>
                <b>Reference No : </b>
                {item.referenceNo}
              </Grid>
              <Grid item xs={6}>
                <b>CC Batch No : </b>
                {item.ccBatchNo}
              </Grid>
              <Grid item xs={12}>
                <b>Remark : </b>
                {item.remark}
              </Grid>
              <Grid item xs={6}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={6}>
                <b>Adjustment Reason: </b>
                {item.reasonCode}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.adjustmentDetails} />
          </div>
        </>
      );
    },
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setAdjRequest(null);
  };

  return (
    <Drawer width="1190px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default AdjustmentDrawer;
